export const EARLY_UPGRADE_CHART_BACKGROUND_COLOR = '#003594'
export const EARLY_UPGRADE_CHART_BORDER_COLOR = '#E9ECEF'
export const EARLY_UPGRADE_CHART_FONT_COLOR = '#ADB5BD'
